export default __webpack_public_path__ + "static/media/cctv.629c5cc2.PNG";